import React, { memo } from 'react';
import Skeleton from './Skeleton';

export const ProductCardSkeleton = memo(function ProductCardSkeleton({ height = 180, style = {} }) {
  return (
    <div
      aria-busy="true"
      style={{
        background: '#FFFFFF',
        borderRadius: 14,
        border: '1.5px solid var(--border, #E5E7EB)',
        overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        ...style,
      }}
    >
      {/* Category / tag strip */}
      <div
        style={{
          background: 'var(--green-lt, #E8F5EE)',
          padding: '10px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', gap: 6 }}>
          <Skeleton variant="rectangular" width={70} height={18} borderRadius={10} />
          <Skeleton variant="rectangular" width={50} height={18} borderRadius={10} />
        </div>
        <Skeleton variant="rectangular" width={60} height={18} borderRadius={10} />
      </div>

      {/* Product Image */}
      <div style={{ position: 'relative', width: '100%', height: height }}>
        <Skeleton variant="rectangular" width="100%" height={height} borderRadius={0} />
      </div>

      {/* Card Body */}
      <div style={{ padding: '16px 16px 14px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          {/* Brand */}
          <Skeleton variant="text" width="40%" height={12} style={{ marginBottom: 8 }} />
          {/* Title */}
          <Skeleton variant="text" width="90%" height={16} style={{ marginBottom: 6 }} />
          <Skeleton variant="text" width="65%" height={16} style={{ marginBottom: 16 }} />
        </div>

        <div>
          {/* Buttons */}
          <div style={{ display: 'flex', gap: 8 }}>
            <Skeleton variant="rectangular" width="50%" height={36} borderRadius={9} />
            <Skeleton variant="rectangular" width="50%" height={36} borderRadius={9} />
          </div>
          {/* Demand tag line */}
          <Skeleton variant="text" width="50%" height={12} style={{ marginTop: 12 }} />
        </div>
      </div>
    </div>
  );
});

export const ProductListSkeleton = memo(function ProductListSkeleton({ count = 6, columns = 3, gap = 20, style = {} }) {
  const gridClass = columns === 4 ? 'grid-1-2-4' : columns === 2 ? 'grid-1-2' : 'grid-1-2-3';
  return (
    <div className={gridClass} style={{ gap, ...style }} aria-busy="true">
      {Array.from({ length: count }).map((_, idx) => (
        <ProductCardSkeleton key={idx} />
      ))}
    </div>
  );
});

export default ProductCardSkeleton;
